var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { Colors, helperButtonReset, helperLinkReset, helperListItemHover, helperTypographyText, } from '@utex/ui-kit';
export var NavItemSecond = styled('a')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  display: block;\n  padding: 0.6rem 2rem;\n  width: 100%;\n  text-align: left;\n  color: ", ";\n  cursor: ", ";\n\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ",
    ";\n  display: block;\n  padding: 0.6rem 2rem;\n  width: 100%;\n  text-align: left;\n  color: ", ";\n  cursor: ", ";\n\n  ",
    ";\n"])), helperLinkReset, helperButtonReset, helperTypographyText({
    size: 'M',
    lh: 'M',
}), function (props) { return props.isDisabled && Colors.text.disabled; }, function (props) { return (props.isDisabled ? 'default' : 'pointer'); }, helperListItemHover({
    activeBgColor: Colors.ut.listItemDown,
}));
var templateObject_1;
//# sourceMappingURL=styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/Navigation/components/TooltipHowItWorks/styles.js
// module id = 1360
// module chunks = 118